import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container create-order" }
const _hoisted_2 = { class: "el-upload__tip" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "form",
        class: "info-form",
        model: _ctx.packageForm,
        rules: _ctx.validateOpRule,
        "label-width": "140px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "目的地国家/地区",
            class: "form-item-input",
            prop: "country"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.packageForm.country,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.packageForm.country) = $event)),
                "value-key": "id",
                placeholder: "请选择国家或地区",
                filterable: "",
                size: "large",
                clearable: "",
                onChange: _ctx.getExpress
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryList, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      (item.miniprogram_order_plugins?.length == 0)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: item.name_cn,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" [" + _toDisplayString(item.name) + "]" + _toDisplayString(item.name_cn), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "onChange"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "承运线路",
            size: "large",
            class: "form-item-input",
            prop: "express_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.packageForm.express_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.packageForm.express_id) = $event)),
                "value-key": "id",
                placeholder: "请选择线路",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.title,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" [" + _toDisplayString(item.id) + "]" + _toDisplayString(item.title), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model", "rules"]),
      _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
        "element-loading-text": "上传中请稍后",
        "element-loading-background": "rgba(0, 0, 0, 0.8)",
        drag: "",
        accept: ".xls, .xlsx,.csv",
        action: "#",
        "http-request": (file) => _ctx.uploadFile(_ctx.packageForm, file),
        multiple: false,
        "show-file-list": false,
        disabled: _ctx.disabledUpload
      }, {
        tip: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createTextVNode(" * 请根据 ")),
            _createVNode(_component_el_link, {
              type: "primary",
              underline: true,
              download: "",
              href: "/templates/templates.xlsx"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("模版")
              ])),
              _: 1 /* STABLE */,
              __: [2]
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" 创建运单，如果有特殊要求可以请在表格中备注字段注明。GLP开头的单号作为您入仓的唯一编号。 "))
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
            default: _withCtx(() => [
              _createVNode(_component_upload_filled)
            ]),
            _: 1 /* STABLE */
          }),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "el-upload__text" }, [
            _createTextVNode("拖拽上传 或 "),
            _createElementVNode("em", null, "点击上传")
          ], -1 /* HOISTED */))
        ]),
        _: 1 /* STABLE */,
        __: [5]
      }, 8 /* PROPS */, ["http-request", "disabled"])), [
        [_directive_loading, _ctx.disabledUpload]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_table, {
            style: {"width":"100%"},
            class: "ordering-list",
            data: _ctx.packageList,
            "row-class-name": _ctx.isValidate
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "package_num",
                label: "订单单号",
                width: "200"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.package_num || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "logistics_code",
                width: "180",
                label: "入仓单号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "logistics_code",
                width: "180",
                label: "收件人姓名"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.firstname) + " " + _toDisplayString(scope.row.last_name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "country",
                label: "国家/地区",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "电话"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.mobile || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "zipcode",
                label: "邮编"
              }),
              _createVNode(_component_el_table_column, {
                prop: "state",
                label: "州"
              }),
              _createVNode(_component_el_table_column, {
                prop: "city",
                label: "城市"
              }),
              _createVNode(_component_el_table_column, {
                prop: "zipcode",
                label: "地址"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.address1) + " " + _toDisplayString(scope.row.address2 ? ', ' + scope.row.address2 : ''), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "note",
                label: "备注"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.note || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "message",
                label: "结果"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", null, _toDisplayString(scope.row.message || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" <el-table-column label=\"操作\" fixed=\"right\" width=\"100\">\n\t\t\t\t\t\t\t<template #default=\"scope\">\n\t\t\t\t\t\t\t\t<el-button-group>\n\t\t\t\t\t\t\t\t\t<z-button\n\t\t\t\t\t\t\t\t\t\ttype=\"primary\"\n\t\t\t\t\t\t\t\t\t\tsize=\"mini\"\n\t\t\t\t\t\t\t\t\t\t@click=\"doRemovePackage(scope.row)\"\n\t\t\t\t\t\t\t\t\t\t><i class=\"el-icon-refresh\"></i>编辑</z-button\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t</el-button-group>\n\t\t\t\t\t\t\t</template>\n\t\t\t\t\t\t</el-table-column> ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["data", "row-class-name"])
        ])
      ])
    ])
  ]))
}